 const swiper = new Swiper(".mySwiper", {
  loop: false,
  speed: 800,
  spaceBetween: 20,
 autoplay:false,
 dots:true,
  breakpoints: {
    0: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    1200: { slidesPerView: 5 }
  }
});


const initProductThumbnail = () => {
  const thumbnailGallery = document.querySelectorAll('.thumbnail-list__item');

  const filterThumbnails = () => {
    const variantSelects = document.querySelectorAll('variant-selects .variant-option-input');

    // Hide all thumbnails first
    thumbnailGallery.forEach((galleryItem) => {
      galleryItem.style.display = 'none';
    });

    variantSelects.forEach((selectedVariant) => {
      // Only process the checked input
      if (!selectedVariant.checked) return;

      console.log(selectedVariant.value.toLowerCase(), "selected variant value");
      // let emptyStr = document.querySelector('.product__text.inline-richtext.key-benefits-class').textContent.trim();
      // let varinatSelectedText = document.querySelector('.product__text.inline-richtext.key-benefits-class').innerHTML.split('|').map(item => item.trim())[1].split(' ')[0];

    const element = document.querySelector(
  '.product__text.inline-richtext.key-benefits-class'
);

if (element) {

  let emptyStr = element.textContent.trim();

  // Split safely
  let parts = emptyStr.split('|').map(item => item.trim());

  // Make sure second part exists
  if (parts.length > 1) {

    // Get first word safely
    let variantSelectedText = parts[1].split(' ')[0];

    console.log(parts, "parts..");

    // Replace first word
    parts[1] = parts[1].replace(/^\S+/, variantSelectedText);

    console.log(parts[1], "parts[1]..");

    // Only update if selectedVariant exists
    if (
      typeof selectedVariant !== "undefined" &&
      selectedVariant.value
    ) {
      parts[1] = `${selectedVariant.value} FLAVOUR`;
    }

    // Join back
    let newStr = parts.join(' | ');

    element.textContent = newStr;

    console.log(newStr, "newstr...");
  }
}

      thumbnailGallery.forEach((galleryItem) => {
        const mediaAlt = galleryItem.getAttribute('data-media-alt');

        if (
          selectedVariant.value.toLowerCase() === mediaAlt ||
          mediaAlt === 'all' ||   // always show if alt is "all"
          mediaAlt === '' ||      // always show if alt is empty/blank
          mediaAlt === null       // ✅ always show if alt attribute is missing
        ) {
          console.log(mediaAlt, "thumbnail gallery data media alt...");
          galleryItem.style.display = '';
        }
      });
    });
  };

  // Run on initial load
  filterThumbnails();

  // Event delegation on document — survives DOM re-renders
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      console.log("variant changed...");
      filterThumbnails();
    }
  });
};

initProductThumbnail();


document.addEventListener('DOMContentLoaded', function () {

 document.querySelectorAll('.custom-buy-now-btn').forEach(function (btn) {

  btn.addEventListener('click', async function () {

    const sectionId = btn.getAttribute('data-section-id');

    // Get variant ID
    const variantInput = document.querySelector(
      `#ProductSubmitButton-${sectionId}`
    )
      ?.closest('form')
      ?.querySelector('[name="id"]');

    const variantId = variantInput
      ? parseInt(variantInput.value)
      : null;

    // Get quantity
    const quantityInput = document.querySelector('[name="quantity"]');

    const quantity = quantityInput
      ? parseInt(quantityInput.value) || 1
      : 1;

    if (!variantId) {
      console.error('Variant ID not found');
      return;
    }

    // Prevent multiple clicks
    if (btn.disabled) return;

    // Store original text
    const originalText = btn.textContent;
    btn.dataset.originalText = originalText;

    // Show loading state
    btn.disabled = true;
    btn.textContent = 'Processing...';

    try {

      // Step 1: Clear existing cart
      await fetch('/cart/clear.json', {
        method: 'POST'
      });

      // Step 2: Add item with quantity
      const addRes = await fetch('/cart/add.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (!addRes.ok) {

        const err = await addRes.json();

        alert(
          err.description ||
          'Could not add item. Please try again.'
        );

        btn.disabled = false;
        btn.textContent = originalText;

        return;
      }

      // Step 3: Redirect to checkout
      window.location.href = '/checkout';

    } catch (err) {

      console.error('Buy Now failed:', err);

      alert('Something went wrong. Please try again.');

      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
});


// Reset button state when user comes back
window.addEventListener('pageshow', function () {

  document.querySelectorAll('.custom-buy-now-btn').forEach(function (btn) {

    btn.disabled = false;

    if (btn.dataset.originalText) {
      btn.textContent = btn.dataset.originalText;
    } else {
      btn.textContent = 'Buy Now';
    }

  });

});

});

/*
 * =========================================================
 * FIX SMART CART PRODUCT TITLE
 * =========================================================
 *
 * The Smart Cart displays the original product title:
 *
 * ION HYDRO CHARGE - lemon lime
 *
 * even when the selected variant is Watermelon.
 *
 * The cart already shows the correct variant underneath:
 *
 * 1 / Watermelon
 * 6 / Watermelon
 *
 * We use that variant value to correct the displayed title.
 * =========================================================
 */

function fixLeoIonSmartCartTitles() {

  const productRows =
    document.querySelectorAll(
      '.easc-productRow'
    );

  productRows.forEach(function (row) {

    const titleElement =
      row.querySelector(
        '.easc-prodTitle'
      );

    if (!titleElement) {
      return;
    }


    /*
     * Find the line containing:
     *
     * 1 / Watermelon
     * 6 / Watermelon
     * etc.
     */
    const variantLine =
      row.querySelector(
        '.easc-prodRowTitle > .ea-normalLineHeight'
      );

    if (!variantLine) {
      return;
    }


    const variantText =
      variantLine.textContent.trim();

    if (!variantText) {
      return;
    }


    /*
     * Extract everything after "/"
     *
     * "1 / Watermelon"
     *          ↓
     * "Watermelon"
     */
    const parts =
      variantText.split('/');

    if (parts.length < 2) {
      return;
    }


    const flavour =
      parts
        .slice(1)
        .join('/')
        .trim();


    if (!flavour) {
      return;
    }


    /*
     * Get current title.
     *
     * Example:
     * ION HYDRO CHARGE - lemon lime
     *
     * becomes:
     * ION HYDRO CHARGE
     */
    let currentTitle =
      titleElement.textContent.trim();

    let baseTitle =
      currentTitle.split(' - ')[0].trim();


    if (!baseTitle) {
      return;
    }


    /*
     * Build correct title.
     */
    const correctTitle =
      baseTitle +
      ' - ' +
      flavour;


    /*
     * Only change if necessary.
     */
    if (
      titleElement.textContent.trim() !==
      correctTitle
    ) {

      titleElement.textContent =
        correctTitle;

      console.log(
        'LeoIon: Cart title corrected:',
        correctTitle
      );

    }

  });

}


/*
 * Run after cart has rendered.
 */
document.addEventListener(
  'DOMContentLoaded',
  function () {

    fixLeoIonSmartCartTitles();

  }
);


/*
 * The Smart Cart can re-render its HTML
 * after Add to Cart / quantity changes.
 *
 * MutationObserver watches for those changes.
 */
const leoIonCartObserver =
  new MutationObserver(
    function () {

      fixLeoIonSmartCartTitles();

    }
  );


/*
 * Start watching the page.
 */
if (document.body) {

  leoIonCartObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

}